import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Terms() {
  return (
    <div className="min-h-screen bg-x1493-dark text-white">
      <Header />
      <main className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-3xl md:text-4xl font-bold text-x1493-secondary mb-8">條款及細則</h1>
        <div className="space-y-6 text-white/80 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-white mb-3">1. 接受條款</h2>
            <p>
              歡迎瀏覽本網站（以下簡稱「本網站」）。當你進入本網站、建立帳戶或落單購買任何產品，即表示你已閱讀、明白並同意受本條款及細則約束。如你不同意，請停止使用本網站。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">2. 產品與價格</h2>
            <p>
              本網站所列產品、價格、規格及圖片僅供參考，我們保留隨時修改而無需事先通知的權利。所有價格以港幣（HKD）計算，並已包含香港本地適用之稅項（如適用）。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">3. 訂單與付款</h2>
            <p>
              落單後，你會收到訂單確認。我們接受轉數快（FPS）／PayMe 等付款方式。訂單會於確認收款後處理。如未能於指定時間內收到付款，我們保留取消訂單的權利。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">4. 送貨</h2>
            <p>
              我們會盡力於確認付款後的指定期間內安排送貨。實際送達時間可能因天氣、交通或第三方物流狀況而有所延誤。偏遠地區或特殊地址可能需額外運費。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">5. 退換政策</h2>
            <p>
              食品類產品一經售出，除產品存在品質問題或運送過程中損壞外，恕不接受退換。如有問題，請於收到產品後 24 小時內透過 WhatsApp 聯絡我們。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">6. 知識產權</h2>
            <p>
              本網站的所有內容，包括但不限於文字、圖片、商標、標誌及設計，均屬本網站營運者所有或已獲合法授權。未經書面許可，不得複製、分發或作商業用途。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">7. 推薦回贈計劃</h2>
            <p>
              參與推薦計劃須遵守額外規則。我們保留調整回贈比例、計算方式及參與資格的權利，並會以誠信原則處理任何濫用或虛假推薦行為。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">8. 責任限制</h2>
            <p>
              在法律允許的最大範圍內，我們不會就因使用或無法使用本網站而引致的任何間接、附帶或懲罰性損失承擔責任。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">9. 條款修訂</h2>
            <p>
              我們保留隨時更新本條款及細則的權利。修訂後的條款將於本頁公佈，繼續使用本網站即表示你接受最新版本。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">10. 聯絡我們</h2>
            <p>
              如有任何疑問，請透過 WhatsApp（852 6232 2466）與我們聯絡。
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
